export type TalkLocales = keyof typeof talkLocales;

export const talkLocales = {
  fr: {
    talkTitle: "Kayn'in Talk",
    closedTitle: "La table ronde est actuellement fermée",
    closedDesc: "Aucun débat n'est en cours. Veuillez revenir plus tard ou consulter l'historique.",
    allDebates: "Tous les débats",
    subtitle: "Table ronde virtuelle : débats et intelligence collective",
    qWeek: "Question de la semaine :",
    adminConc: "Conclusion :",
    takeFloor: "Prendre la parole",
    debateClosed: "Ce débat est clôturé",
    allComments: "Tous les commentaires",
    formTitle: "Prendre la parole",
    formDesc: "Contribuez avec votre langue de préférence",
    prefLangLabel: "Langue de préférence",
    commentLabel: "Votre commentaire",
    commentPlaceholder: "Rédigez un commentaire concis et ciblé...",
    domainLabel: "Domaine suggéré (optionnel)",
    domainSelect: "-- Choisir --",
    domainOther: "Autre domaine...",
    domainOtherPlaceholder: "Saisir le domaine (2 mots max)",
    questionLabel: "Proposer une question (optionnel)",
    questionPlaceholder: "Une question pour le prochain débat...",
    ethics: "Je certifie que mon commentaire respecte la charte éthique de la plateforme et ne contient aucun discours de haine.",
    publish: "Publier mon commentaire",
    moderation: "Votre commentaire sera vérifié par notre équipe avant d'être affiché publiquement.",
    successTitle: "Envoyé avec succès !",
    successDesc: "Merci pour votre contribution. Elle sera publiée après modération.",
    close: "Fermer",
    alreadyParticipated: "Vous avez déjà participé !",
    alreadyParticipatedDesc: "Vous avez déjà apporté votre précieuse contribution. Afin de favoriser l'intelligence collective et de permettre à chacun de s'exprimer, la parole est désormais donnée aux autres participants. Kayn'in vous remercie chaleureusement !",
    domEducation: "Éducation",
    domSante: "Santé",
    domEco: "Économie / Emploi",
    domInfra: "Infrastructure",
    domTransport: "Transport",
    domEnv: "Environnement",
    domJustice: "Justice",
    domCulture: "Culture",
    domDigitale: "Digitale",
  },
  ar: {
    talkTitle: "نقاش كاينين",
    closedTitle: "المائدة المستديرة مغلقة حاليا",
    closedDesc: "لا يوجد أي نقاش مفتوح حاليا. يرجى العودة لاحقا أو استكشاف الأرشيف.",
    allDebates: "كل النقاشات",
    subtitle: "مائدة مستديرة افتراضية: نقاشات وذكاء جماعي",
    qWeek: "سؤال الأسبوع:",
    adminConc: "خلاصة:",
    takeFloor: "أخذ الكلمة",
    debateClosed: "تم إغلاق هذا النقاش",
    allComments: "كل التعليقات",
    formTitle: "أخذ الكلمة",
    formDesc: "ساهم بلغتك المفضلة",
    prefLangLabel: "لغة التعبير المفضلة",
    commentLabel: "تعليقك",
    commentPlaceholder: "اكتب تعليقك هنا بشكل مقتضب ومباشر...",
    domainLabel: "مجال السؤال المقترح (اختياري)",
    domainSelect: "-- اختر مجالا --",
    domainOther: "مجال آخر...",
    domainOtherPlaceholder: "اكتب المجال (كلمتين كحد أقصى)",
    questionLabel: "اقتراح سؤال (اختياري)",
    questionPlaceholder: "سؤال مقترح للنقاش القادم...",
    ethics: "أقر بأن تعليقي يحترم الميثاق الأخلاقي للمنصة، وأنه خالٍ من لغة التجريح والكراهية.",
    publish: "نشر التعليق",
    moderation: "سيتم التحقق من تعليقك من طرف الإدارة قبل نشره للعموم.",
    successTitle: "تم الإرسال بنجاح!",
    successDesc: "شكرًا لمشاركتك. سيتم نشره بعد المراجعة.",
    close: "إغلاق",
    alreadyParticipated: "لقد شاركت بالفعل!",
    alreadyParticipatedDesc: "لقد سبق لك أن شاركت برأيك القيم في هذه المائدة المستديرة. حرصاً منا على تعزيز الذكاء الجماعي وإتاحة الفرصة للجميع للتعبير، نمنح الكلمة الآن لباقي المشاركين. نشكرك بحرارة على تفاعلك!",
    domEducation: "التعليم",
    domSante: "الصحة",
    domEco: "الاقتصاد / التشغيل",
    domInfra: "البنية التحتية",
    domTransport: "النقل",
    domEnv: "البيئة",
    domJustice: "العدل",
    domCulture: "الثقافة",
    domDigitale: "الرقمنة",
  },
  zgh: {
    talkTitle: "ⴰⵡⴰⵍ ⵏ Kayn'in",
    closedTitle: "ⵟⴰⴱⵍⴰ ⵏ ⵡⴰⵡⴰⵍ ⵜⵇⵏ ⴷⵖⴰ",
    closedDesc: "ⵓⵔ ⵉⵍⵍⵉ ⵓⵍⴰ ⵢⴰⵏ ⵓⵙⵇⵙⵉ. ⴰⵔⵊⵓ ⵎⴰⴷ ⴷ ⵉⵜⴷⴷⵓⵏ ⵏⵖ ⵥⵕ ⴰⵎⵣⵔⵓⵢ.",
    allDebates: "ⴰⴽⴽⵯ ⵉⵙⵇⵙⵉⵢⵏ",
    subtitle: "ⵟⴰⴱⵍⴰ ⵏ ⵡⴰⵡⴰⵍ ⵏ ⵉⵏⵜⵔⵏⵜ: ⵉⵎⵙⵍⴰⵢⵏ ⴷ ⵜⵓⵙⵙⵏⴰ ⵏ ⵙⵎⵓⵏ",
    qWeek: "ⴰⵙⵇⵙⵉ ⵏ ⵉⵎⴰⵍⴰⵙ:",
    adminConc: "ⵜⴰⴳⴳⴰⵔⴰ:",
    takeFloor: "ⴰⵎⵥ ⴰⵡⴰⵍ",
    debateClosed: "ⴰⵎⵙⵍⴰⵢ ⴰⴷ ⵉⵇⵏ",
    allComments: "ⴰⴽⴽⵯ ⵉⵡⵏⵏⵉⵜⵏ",
    formTitle: "ⴰⵎⵥ ⴰⵡⴰⵍ",
    formDesc: "ⵜⵜⴽⴽⵉ ⵙ ⵜⵓⵜⵍⴰⵢⵜ ⵏⵏⴽ",
    prefLangLabel: "ⵜⵓⵜⵍⴰⵢⵜ ⵉ ⵜⴱⵖⵉⴷ",
    commentLabel: "ⴰⵡⵏⵏⵉⵜ ⵏⵏⴽ",
    commentPlaceholder: "ⴰⵔⵓ ⴰⵡⵏⵏⵉⵜ ⵏⵏⴽ ⴷⴰ...",
    domainLabel: "ⴰⵃⵔⵉⵛ ⵉⵛⵓⴷⴷⵏ (ⴰⵅⵜⵉⵢⴰⵔⵉ)",
    domainSelect: "-- ⴼⵔⵏ ⴰⵃⵔⵉⵛ --",
    domainOther: "ⴰⵃⵔⵉⵛ ⵢⴰⴹⵏ...",
    domainOtherPlaceholder: "ⴰⵔⵓ ⴰⵃⵔⵉⵛ (2 ⵡⴰⵡⴰⵍⵏ ⵙ ⵓⴳⴰⵔ)",
    questionLabel: "ⴼⴽ ⵜⵓⵜⵜⵔⴰ (ⴰⵅⵜⵉⵢⴰⵔⵉ)",
    questionPlaceholder: "ⵜⵓⵜⵜⵔⴰ ⵉ ⵓⵎⵙⵍⴰⵢ ⴷ ⵢⵓⵙⴰⵏ...",
    ethics: "ⵣⵣⴰⵢⵖ ⴱⵍⵍⵉ ⴰⵡⵏⵏⵉⵜ ⵉⵏⵓ ⵉⵇⴰⴷⵔ ⵍⵎⵉⵜⴰⵇ ⵏ ⵜⵙⴷⴷⴰⵔⵜ, ⵓⵔ ⵉⵍⵍⵉ ⵡⴰⵡⴰⵍ ⵏ ⵍⴽⵕⴰⵀ.",
    publish: "ⴼⵙⵔ ⴰⵡⵏⵏⵉⵜ ⵉⵏⵓ",
    moderation: "ⴰⵡⵏⵏⵉⵜ ⵏⵏⴽ ⴰⴷ ⵢⵉⵍⵉ ⵓⵙⵏⵇⴷ ⵇⴱⵍ ⴰⵙⴼⵙⵔ.",
    successTitle: "ⵉⵜⵜⵡⴰⵣⵏ ⵙ ⵍⴼⵔⵃ!",
    successDesc: "ⵜⴰⵏⵎⵎⵉⵔⵜ ⴼ ⵓⵜⵜⴽⴽⵉ ⵏⵏⴽ. ⴰⴷ ⵉⵜⵜⵡⴰⴼⵙⵔ ⴷⴼⴼⵉⵔ ⵓⵡⵍⵉ.",
    close: "ⵔⴳⵍ",
    alreadyParticipated: "ⵜⵜⴽⴽⵉⴷ ⵢⴰⴷ!",
    alreadyParticipatedDesc: "ⵜⵜⴽⴽⵉⴷ ⵢⴰⴷ ⵖ ⵉⵙⵇⵙⵉⵢⵏ ⴰⴷ. ⴰⴼⴰⴷ ⴰⴷ ⵏⵙⵙⵓⴼⵖ ⵜⵓⵙⵙⵏⴰ ⵏ ⵙⵎⵓⵏ ⴷ ⵓⴷⵎⵎⴰ ⴰⴷ ⵢⴰⵡⴰⵍ ⴽⵓⵢⴰⵏ, ⴰⵡⴰⵍ ⵉⵍⵍⴰ ⴷⴰⵔ ⵡⵉⵢⵢⴰⴹ ⴷ ⵎⴰⴷ ⵔⴰⵏ. Kayn'in ⵜⵙⵏⵎⵎⵉⵔⵜ ⴽ ⴱⴰⵀⵔⴰ!",
    domEducation: "ⴰⵙⴳⵎⵉ",
    domSante: "ⵜⴰⴷⴰⵡⵙⴰ",
    domEco: "ⵜⴰⴷⴰⵎⵙⴰ / ⴰⵎⴰⵀⵉⵍ",
    domInfra: "ⵜⵉⵏⵖⵔⴰⵎⵉⵏ",
    domTransport: "ⴰⵙⵉⴽⵍ",
    domEnv: "ⵜⴰⵡⵏⵏⴰⴹⵜ",
    domJustice: "ⵜⴰⵏⵣⵣⵔⴰⴼⵜ",
    domCulture: "ⵜⴰⴷⵍⵙⴰ",
    domDigitale: "ⴰⵙⵉⴷⵏ",
  }
};
